import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CollectionService } from '@services/collection.service';
import { NotificationService } from '@services/notification.service';
import { Subscription } from 'rxjs';
import { AddCollectionComponent } from '../add-collection/add-collection.component';
import { WebErrorService } from '@services/webError.service';
import { customValidationService } from 'src/app/shared/custom.validator';

@Component({
  selector: 'app-edit-collection',
  templateUrl: './edit-collection.component.html',
  styleUrls: ['./edit-collection.component.scss'],
})
export class EditCollectionComponent implements OnInit, OnDestroy {
  // variable declaration
  timeZone: any;
  language: string;
  languagesData$: Subscription | undefined;
  timeZoneData$: Subscription | undefined;
  collectionPostData$: Subscription | undefined;
  languageArr = [];
  timeZoneArr = [];
  globalcollectionuuId: any;
  userForm: FormGroup;
  collection: any;
  selectedLanguage: any;
  selectedTimeZone: any;
  collectionUpdateData: any;
  collectionNameDisplay: any;
  collectionDescriptionDisplay: any;

  constructor(
    private collectionService: CollectionService,
    private notificationService: NotificationService,
    private router: Router,
    public dialog: MatDialog,
    private webErrorService: WebErrorService
  ) {
    const readUrl = this.router.url;
    const url1 = readUrl.split('/');
    this.globalcollectionuuId = url1[2];
  }

  ngOnInit(): void {
    // this.globalcollectionuuId = JSON.parse(
    //   localStorage.getItem('defaultcollectionid')
    // );

    this.languagesData$ = this.collectionService
      .getLanguages()
      ?.subscribe((languagesData: any) => {
        this.languageArr = languagesData?.items;
        this.selectedLanguage = 'English';
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });

    this.timeZoneData$ = this.collectionService
      .getTimeZone()
      ?.subscribe((timeZoneData: any) => {
        this.timeZoneArr = timeZoneData?.items;
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });

    this.userForm = new FormGroup({
      collectionName: new FormControl(null, [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(120),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/)
      ]),
      description: new FormControl(null, [Validators.minLength(1), Validators.maxLength(480)]),
      langid: new FormControl(null, [Validators.required]),
      timezoneid: new FormControl(null, [Validators.required]),
    });

    this.collectionService
      .getCollectionDetails(this.globalcollectionuuId)
      .subscribe((result) => {
        this.collection = result?.data;
        this.collectionNameDisplay = this.collection?.collectionName;
        this.collectionDescriptionDisplay = this.collection?.description;
        this.userForm
          .get('collectionName')
          .setValue(this.collection?.collectionName);
        this.userForm.get('description').setValue(this.collection?.description);
        let selectedLanguage = this.userForm
          .get('langid')
          .setValue(this.collection?.langid);
        let timeZone = this.userForm
          .get('timezoneid')
          .setValue(this.collection?.timezone);
        // this.selectedLanguage = this.collection?.language;
        // this.selectedTimeZone = this.collection?.timezone;
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });

    // this.shareDataService.collectionData.subscribe(collectionData => {
    //   if (collectionData) {
    //     this.userForm.setValue({
    //       collectionName: collectionData?.collectionName,
    //       description: collectionData?.description,
    //       langid: collectionData?.langid,
    //       timezoneid: collectionData?.timezoneid
    //     });
    //   }
    // });
  }

  get f(): any {
    return this.userForm.controls;
  }

  saveBtnFn(): void {
    if (this.userForm.value.description != null) {
      this.userForm.value.description = this.userForm.value.description.trim();
    } else {
      this.userForm.value.description = this.userForm.value.description;
    }
    const apiData = {
      collectionName: this.userForm.value.collectionName.trim(),
      description: this.userForm.value.description,
      langid: this.userForm.value.langid,
      timezoneName: this.userForm.value.timezoneid
      // timezoneid: this.userForm.value.timezoneid,
    };

    this.collectionService
      .UpdateCollectionDetails(this.globalcollectionuuId, apiData)
      ?.subscribe(
        (data) => {
          this.collectionService.getCollection()?.subscribe(resData => {
            this.collectionService.newCollectionList(resData);
          });
          this.dialog.closeAll()
          this.notificationService.success(data?.message);
          // this.router.navigate(['collections']);


        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, '', true, 'warn');
          // this.userForm.reset()
          this.userForm.controls['collectionName'].reset()
        }
      );
  }
  navigatetoCollection(): void {
    this.router.navigate(['/collections']);
  }

  openEditCollectionDialog(): void {
    const dialogConfig: MatDialogConfig<AddCollectionComponent> = {
      minWidth: '650px',
    };
    const dialogRef = this.dialog.open(AddCollectionComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  ngOnDestroy(): void {
    this.languagesData$?.unsubscribe();
    this.timeZoneData$?.unsubscribe();
    this.collectionPostData$?.unsubscribe();
  }
}
